import * as React from 'react'

import { BaseEventModel } from 'app/models/baseEventModel'
import { MinimalPaymentCountryModel } from 'app/models/minimalPaymentCountryModel'

import { useScene } from '../context/SceneContext'

const HEIGHT = 7
const BELOW_VIOLATION_TOP = 5
const color = '#B200FC'

export type MinimalPaymentCountryBlockProps = {
  minimalPaymentCountry: MinimalPaymentCountryModel
  index: number
  belowViolation?: boolean
}

export const MinimalPaymentCountryBlock: React.FC<MinimalPaymentCountryBlockProps> =
  React.memo((props: MinimalPaymentCountryBlockProps) => {
    const scene = useScene()

    const minimalPaymentCountry = props.minimalPaymentCountry

    const prepareTooltipInfo = (): BaseEventModel => {
      const info: BaseEventModel = {
        startTime: minimalPaymentCountry.startTime,
        endTime: minimalPaymentCountry.endTime,
        typeName: 'eventName.minimalPaymentCountry',
        color,
      }
      return info
    }

    const width = scene.widthOf(
      minimalPaymentCountry.startTime,
      minimalPaymentCountry.endTime,
    )
    const position = scene.timeToX(minimalPaymentCountry.startTime)

    const top = props.belowViolation ? BELOW_VIOLATION_TOP : 0

    return (
      <div
        style={{
          position: 'absolute',
          left: position,
          top: 0,
          bottom: 0,
        }}
      >
        <div
          className={
            minimalPaymentCountry.isTransit ? 'sinusoid' : 'sinusoid-gray'
          }
          data-tip={JSON.stringify(prepareTooltipInfo())}
          data-for="eventTooltip"
          style={{
            position: 'absolute',
            top,
            left: 0,
            height: HEIGHT,
            width: width,
            opacity: 1,
            pointerEvents: 'auto',
          }}
        />
      </div>
    )
  })

MinimalPaymentCountryBlock.displayName = 'MinimalPaymentCountryBlock'
